var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeeth38(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_2777_3288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7307 10.0907C8.72975 12.413 3.92867 18.6058 4.72885 28.6692C5.52903 38.7326 23.9332 63.5041 39.1366 58.8594C51.9395 54.9889 58.341 42.6032 56.7406 27.121C54.3401 10.8648 49.539 7.76833 44.7379 8.54244C39.9368 9.31655 34.3355 10.0907 30.3346 10.0907C26.3337 10.0907 19.9323 5.44601 12.7307 10.0907Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7809 10.1771L12.7809 10.1772L12.7849 10.1747C16.3571 7.87077 19.7292 7.8696 22.7139 8.44709C23.95 8.68626 25.1175 9.02418 26.2074 9.33965C26.4355 9.40568 26.6602 9.47073 26.8815 9.53368C28.1554 9.89614 29.3185 10.1907 30.3346 10.1907C34.3446 10.1907 39.9532 9.41519 44.7538 8.64117C45.941 8.44975 47.1231 8.49833 48.2662 8.92638C49.4089 9.35432 50.5197 10.1642 51.5604 11.5066C53.6446 14.1949 55.4418 19.0114 56.6414 27.1335C58.2377 42.583 51.8502 54.9114 39.1077 58.7637L39.1074 58.7638C35.3374 59.9155 31.3628 59.2459 27.5016 57.4264C23.6401 55.6068 19.8989 52.64 16.6036 49.2106C13.3087 45.7816 10.4631 41.8936 8.39167 38.2358C6.31879 34.5755 5.02686 31.1555 4.82853 28.6613C4.03133 18.6354 8.81402 12.4797 12.7809 10.1771Z",
    stroke: "white",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2777_3288",
    x: 0.640625,
    y: 0.0263672,
    width: 60.3438,
    height: 59.4072,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2777_3288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2777_3288",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeeth38);
export default __webpack_public_path__ + "static/media/teeth38.eca9c83d6c327f00aba1284235004cfd.svg";
export { ForwardRef as ReactComponent };